"use client";

import { c as _c } from "react/compiler-runtime";
import { Suspense, useState } from "react";
import { useRouter } from "next/navigation";
import { Headings } from "../data/data";
import { Box, Text, HStack, Image, VisuallyHidden, Link, Flex } from "@chakra-ui/react";
import Heading, { HeadingProps } from "./heading";
import ReportAddress from "./report-address";
import SearchBar from "./search-bar";
import Share from "./share";
import ShareSkeleton from "./share-skeleton";
export type HazardData = {
  liquefaction: {
    exists: boolean;
    last_updated: string | null;
  } | null;
  softStory: {
    exists: boolean;
    last_updated: string | null;
  } | null;
  tsunami: {
    exists: boolean;
    last_updated: string | null;
  } | null;
};
interface HomeHeaderProps {
  searchedAddress: string | null;
  isSearchComplete: boolean;
  onSearchChange: (coords: number[], address: string) => void;
}
const HomeHeader = t0 => {
  const $ = _c(32);
  const {
    searchedAddress,
    isSearchComplete,
    onSearchChange
  } = t0;
  const [inputAddress, setInputAddress] = useState("");
  const headingData = Headings.home;
  const router = useRouter();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      base: "4",
      "2xl": "5"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      base: "column",
      md: "column",
      lg: "row-reverse"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      base: "flex-start",
      xl: "center"
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      base: "2"
    };
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== router) {
    t5 = e => {
      e.preventDefault();
      setInputAddress("");
      router.push("/");
    };
    $[4] = router;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <HStack align="baseline"><Image src="/images/SFSafeHome-fulllogo.svg" alt="SafeHome logo" role="img" height="safeHomeLogoHeight" width="safeHomeLogoWidth" /><VisuallyHidden>SafeHome</VisuallyHidden></HStack>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== t5) {
    t7 = <Link as="a" color="white" href="/" cursor="button" textDecoration="none" onClick={t5}>{t6}{" "}</Link>;
    $[7] = t5;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Text textStyle="textPrerelease" layerStyle="prerelease">Beta</Text>;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t7) {
    t9 = <HStack align="start" gap="1">{t7}{t8}</HStack>;
    $[10] = t7;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== isSearchComplete || $[13] !== searchedAddress) {
    t10 = isSearchComplete ? <ReportAddress searchedAddress={searchedAddress} /> : <Heading headingData={headingData} />;
    $[12] = isSearchComplete;
    $[13] = searchedAddress;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t9) {
    t11 = <Flex direction={t2} justifyContent="space-between" alignItems={t3} gap="1.5" mb={t4}>{t9}{t10}</Flex>;
    $[15] = t10;
    $[16] = t9;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  let t12;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      base: "column-reverse",
      xl: "row"
    };
    $[18] = t12;
  } else {
    t12 = $[18];
  }
  let t13;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      base: "flex-start",
      xl: "center"
    };
    $[19] = t13;
  } else {
    t13 = $[19];
  }
  let t14;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = {
      base: "full",
      xl: "fit"
    };
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== inputAddress || $[22] !== onSearchChange) {
    t15 = <Box width={t14}><SearchBar inputAddress={inputAddress} onInputAddressChange={setInputAddress} onSearchChange={onSearchChange} /></Box>;
    $[21] = inputAddress;
    $[22] = onSearchChange;
    $[23] = t15;
  } else {
    t15 = $[23];
  }
  let t16;
  if ($[24] !== isSearchComplete) {
    t16 = isSearchComplete ? <Suspense fallback={<ShareSkeleton />}><Share /></Suspense> : null;
    $[24] = isSearchComplete;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t15 || $[27] !== t16) {
    t17 = <Flex direction={t12} justifyContent="space-between" alignItems={t13}>{t15}{t16}</Flex>;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  let t18;
  if ($[29] !== t11 || $[30] !== t17) {
    t18 = <Box as="header" bgGradient="blue" py={t1} px="8">{t11}{t17}</Box>;
    $[29] = t11;
    $[30] = t17;
    $[31] = t18;
  } else {
    t18 = $[31];
  }
  return t18;
};
export default HomeHeader;